import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from 'src/app/services/role.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import { environment } from 'src/environments/environment';
import { TournamentDrawService } from 'src/app/services/tournament-draw.service';
import { CategoryService } from 'src/app/services/category.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { ConfirmationService, MessageService } from 'primeng/api';
//import html2canvas from 'html2canvas';
@Component({
  selector: 'app-tournament-draw',
  templateUrl: './draws.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./draws.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class TournamentDrawsComponent implements OnInit {
  @ViewChild('captureMe') captureMe: ElementRef;
  public isHighlighted = false;
  public categoryList;
  public ageGroupList;
  public submitted = false;
  public drawForm: FormGroup;
  public scoreForm: FormGroup;
  public scoreInputForm: FormGroup;
  public activeIndex: number = 0;
  public errorMessage;
  public role;
  public roleId;
  public playerList: any[] = [];
  public selectedPlayerList: any[] = [];
  public playerId;
  public oldPlayer;
  public showInfo: boolean = false;
  public disableDropDown: boolean = false;
  public totalEntries;
  public totalEntriesArray: any[] = [];
  public secondRoundArray: any[] = [];
  public thirdRoundArray: any[] = [];
  public fourthRoundArray: any[] = [];
  public fifthRoundArray: any[] = [];
  public sixthRoundArray: any[] = [];
  public seventhRoundArray: any[] = [];
  public eightRoundArray: any[] = [];
  public roundResult: any[] = [];
  public tournamentId;
  public items;
  public selectedGroupId;
  public selectedAgeGroupId;
  public showScoreForm: boolean = false;
  public playerOneDetails;
  public playerTwoDetails;
  public showScoreInputError: boolean = false;
  public matchConcedeCategories: any = [];
  public selectedMatchConcedeCategory;
  public selectedPlayerValue;
  public showPlayerRadioButtons: boolean = false;
  public playerScoreArray: any = [];
  public showSetScoreTable: boolean = false;
  public totalSets: any = [];
  public playerPosition;
  public showDetailScoringCheckBox: boolean = true;
  public playerOneId;
  public playerTwoId;
  public playerOneInputValue: number = 0;
  public playerTwoInputValue: number = 0;
  public round;
  public result;
  public formControlNumberOne;
  public formControlNumberTwo;
  public countForBye: any = 0;
  public tournamentName;
  public loggedInAcademy;
  public loggedInAcademyUserId;
  public loggedInAcademyId;
  public showRadioButtonError: boolean = false;
  public errorOneResult: boolean = false;
  public detailResultError: boolean = false;
  public scoreSubmitted: boolean = false;
  public showWrongScoreError: boolean = false;
  public saveDrawButtonDisable: boolean = true;
  public drawStatus: boolean = false;
  public isTournamentDrawView: boolean = false;
  public tournamentCategoryId;
  public roundArray = environment.roundArray;
  public isBye: boolean = false;
  public formControlNumber;
  public playersCount: any;
  @ViewChild('playerOneResetButton') playerOneResetButton: ElementRef;
  @ViewChild('playerTwoResetButton') playerTwoResetButton: ElementRef;
  @ViewChild('playerTwoDropDown') playerTwoDropDown: ElementRef;
  helpPopupModal: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private elementRef: ElementRef,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private tournamentService: TournamentsService,
    private tournamentDrawService: TournamentDrawService,
    private categoryService: CategoryService,
    private tokenStorageService: TokenStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }
  ngOnInit(): void {
    this.loggedInAcademy = this.tokenStorageService.getUser();
    this.loggedInAcademyUserId = this.loggedInAcademy.userdata['id'];
    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    let academyPaymentDetails = this.loggedInAcademy.userdata.academyPaymentDetails;
    let roleName = this.loggedInAcademy.userdata.rolename;
    let currentUrl = '/';
    if (roleName == "academy") {
      if (Object.keys(academyPaymentDetails).length > 0) {
        if (academyPaymentDetails.academyPaymentStatus == 'created') {
          currentUrl = '/payment-history';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      } else {
        currentUrl = '/payment-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
      this.isTournamentDrawView = true
    } else {
      this.isTournamentDrawView = false
    }
    this.scoreForm = this.formBuilder.group({
      playerOne: ['',],
      playerTwo: ['',],
      matchConcedeCategoryDropDown: [],
      matchConcedeCategoryCheckbox: [],
      playerOneRadio: [],
      playerTwoRadio: []
    });
    this.tournamentId = this.activeRoute.snapshot.paramMap.get('id');
    this.drawForm = this.formBuilder.group({
      categoryType: ['', [Validators.required]],
      ageGroup: ['', [Validators.required]],
    });
    this.scoreInputForm = this.formBuilder.group({
      scoreArray: this.formBuilder.array([])
    });
    this.getRoles();
    this.getTournamentDetails(this.tournamentId);
    this.getTournamentCategory(this.tournamentId);
    this.getTournamentMatchConcedeCategories();
  }
  get f() {
    return this.drawForm.controls;
  }
  get sf() {
    return this.scoreInputForm.controls;
  }
  scoreSectionForm(): FormArray {
    return this.scoreInputForm.get("scoreArray") as FormArray;
  }
  async getTournamentDetails(id) {
    this.tournamentService.getTournamentDetailsByID(id).subscribe(res => {
      this.items = res;
      this.tournamentName = this.items.name;
    })
  }
  async getTournamentCategory(id) {
    let query = "getMatchtype=true";
    this.tournamentService.getTournamentCategory(id, query).subscribe(
      data => {
        if (data) {
          this.categoryList = data.items;
        }
      },
      (err) => {
      }
    );
  }
  getTournamentMatchConcedeCategories() {
    let parentList = this.tokenStorageService.getCategorylist();
    let obj = parentList.find(o => o.slug === "match_conceded_type");
    if (obj.id) {
      let query = "?filterByDisable=false&filterByStatus=true&filterByParent=" + obj.id + "&sortBy=created_at&orderBy=1";
      this.categoryService.getCategoryList(query).subscribe(
        data => {
          let matchConcedeCategories = data.data.items;
          matchConcedeCategories.forEach(element => {
            this.matchConcedeCategories.push({ name: element.name, value: element.id, slug: element.slug });
          })
        },
        err => {
          this.errorMessage = err.error.message;
        }
      );
    }
  }
  onSelectCategory(event) {
    this.selectedGroupId = event.value.matchTypeId;
    let query = "getAgeGroup=true&matchtype=" + event.value.matchTypeId;
    this.tournamentService.getTournamentCategory(this.tournamentId, query).subscribe(
      data => {
        this.ageGroupList = [];
        if (data) {
          this.totalEntries = '';
          this.totalEntriesArray = [];
          this.secondRoundArray = [];
          this.thirdRoundArray = [];
          this.fourthRoundArray = [];
          this.fifthRoundArray = [];
          this.sixthRoundArray = [];
          this.seventhRoundArray = [];
          this.eightRoundArray = [];
          this.playerOneDetails = [];
          this.playerTwoDetails = [];
          this.selectedPlayerList = [];
          this.playerList = [];
          this.selectedAgeGroupId = undefined;
          this.saveDrawButtonDisable = true;
          this.drawForm.controls.ageGroup.setValue('');
          this.ageGroupList = data.items;
        }
      },
      (err) => {
      });
  }
  onAgeGroupSelect(event) {
    this.totalEntries = '';
    this.totalEntriesArray = [];
    this.secondRoundArray = [];
    this.thirdRoundArray = [];
    this.fourthRoundArray = [];
    this.fifthRoundArray = [];
    this.sixthRoundArray = [];
    this.seventhRoundArray = [];
    this.eightRoundArray = [];
    this.playerOneDetails = [];
    this.playerTwoDetails = [];
    this.selectedPlayerList = [];
    this.playerList = [];
    this.saveDrawButtonDisable = true;
    this.selectedAgeGroupId = event.value.ageGroupId;
    this.drawStatus = event.value.drawStatus;
    this.totalEntries = event.value.maxPlayer;
    this.tournamentCategoryId = event.value.tournamentCategoryId;
    for (let i = 0; i < this.totalEntries; i++) {
      let control = "player" + (i + 1);
      this.drawForm.addControl(control, new FormControl());
      this.drawForm.addControl("reset_player" + (i + 1), new FormControl());
      this.drawForm.addControl("reset_player" + (i + 1) + "_position", new FormControl());
      this.drawForm.get(control).enable();
      this.totalEntriesArray.push(i);
    }
    let secondRound = Number(this.totalEntries) / 2;
    let index = 1;
    for (let i = 0; i < secondRound; i++) {
      this.secondRoundArray.push({ index: index });
      index = index + 2;
    }
    let thirdIndex = 1;
    let thirdRound = Number(secondRound) / 2;
    for (let i = 0; i < thirdRound; i++) {
      this.thirdRoundArray.push({ index: thirdIndex });
      thirdIndex = thirdIndex + 4;
    }
    let fourthIndex = 1;
    let fourthRound = Number(thirdRound) / 2;
    for (let i = 0; i < fourthRound; i++) {
      this.fourthRoundArray.push({ index: fourthIndex });
      fourthIndex = fourthIndex + 8;
    }
    if (Number(this.totalEntries) === Number(16) || Number(this.totalEntries) === Number(32) || Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
      let fifthIndex = 1;
      let fifthRound = Number(fourthRound) / 2;
      for (let i = 0; i < fifthRound; i++) {
        this.fifthRoundArray.push({ index: fifthIndex });
        fifthIndex = fifthIndex + 16;
      }
      if (Number(this.totalEntries) === Number(32) || Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
        let sixthIndex = 1;
        let sixthRound = Number(fifthRound) / 2;
        for (let i = 0; i < sixthRound; i++) {
          this.sixthRoundArray.push({ index: sixthIndex });
          sixthIndex = sixthIndex + 32;
        }
        if (Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
          let seventhIndex = 1;
          let seventhRound = Number(sixthRound) / 2;
          for (let i = 0; i < seventhRound; i++) {
            this.seventhRoundArray.push({ index: seventhIndex });
            seventhIndex = seventhIndex + 64;
          }
          if (Number(this.totalEntries) === Number(128)) {
            let eightIndex = 1;
            let eightRound = Number(seventhRound) / 2;
            for (let i = 0; i < eightRound; i++) {
              this.eightRoundArray.push({ index: eightIndex });
              eightIndex = seventhIndex + 128;
            }
          }
        }
      }

    }
    this.getPlayers(this.selectedAgeGroupId);
  }
  getRoles() {
    let query = "filterByDisable=false&filterByroleName=player";
    this.roleService.getRoleListWithoutAuth(query).subscribe(
      data => {
        if (data.data.items) {
          this.role = data.data.items[0];
          this.roleId = this.role.id;
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getPlayers(selectedAgeGroupId) {
    this.playerList = [];
    let query = "filterByDisabled=false&filterByStatus=true&filterByMatchId=" + this.selectedGroupId + "&filterByAgeGroup=" + selectedAgeGroupId;
    this.tournamentService.getTournamentPlayers(this.tournamentId, query).subscribe(
      data => {
        let playerList = data.items;
        if (playerList.length > 0) {
          this.playersCount = playerList.length;
          playerList.forEach(element => {
            let playerObj = {
              id: element.userId,
              name: element.playerName,
              role: element.playerRole,
              disabled: false
            }
            this.playerList.push(playerObj);
          });
        }
        if (this.playerList.length > 0) {
          let byObj = {
            id: 'bye',
            name: 'Bye',
            disabled: false
          }
          this.playerList.push(byObj);
        }
        // if (this.countForBye == 0) {
        //   this.playerList.push(byObj);
        // } else {
        //   let index = this.findIndexById(byObj.id, this.playerList);
        //   console.log(index);
        //   console.log(this.playerList);
        //   if (index == -1) {
        //     this.playerList.push(byObj);
        //   }
        // }
        this.countForBye++;
        this.getPlayersPositions();
      },
      error => {
      }
    );
  }
  getPlayersPositions() {
    let query = "filterByDisable=false&filterByStatus=true&filterByTournamentId=" + this.tournamentId + "&filterByMatchId=" + this.selectedGroupId + "&filterByAgeGroup=" + this.selectedAgeGroupId;
    this.tournamentDrawService.getTournamentsPlayerPositionList(query).subscribe(
      data => {
        let playerPositionArray = data.data.items;
        for (let i = 0; i < this.totalEntries; i++) {
          let playerDot = 'player' + (i + 1) + '_dot';
          this.elementRef.nativeElement.querySelector('#' + playerDot).style.display = "none ";
        }
        if (playerPositionArray.length > 0) {
          playerPositionArray.forEach(element => {
           
            let setValue = {};
            let playerObj = {};
            let control = 'player' + element.playerPosition;
            let reset = 'reset_' + 'player' + element.playerPosition;
            if (element.isBye === true) {
              let byeId = 'player' + element.playerPosition + "bye";
              setValue = {
                id: 'bye',
                name: 'Bye',
                disabled: false
              }
              playerObj = {
                id: byeId,
                name: 'Bye',
                position: element.playerPosition,
                disabled: false
              }
              this.drawForm.get(control).setValue(setValue);
              this.drawForm.controls[reset].setValue(byeId);
            } else {
              setValue = {
                id: element.playerData[0]._id,
                name: element.playerData[0].fullName,
                role: element.playerRole,
                disabled: false
              }
              this.drawForm.get(control).setValue(setValue);
              this.drawForm.controls[reset].setValue(element.playerData[0]._id);
              let index = this.findIndexById(element.playerData[0]._id, this.playerList);
              if (index !== -1) {
                this.playerList.splice(index, 1);
              }
              playerObj = {
                id: element.playerData[0]._id,
                name: element.playerData[0].fullName,
                position: element.playerPosition,
                role: element.playerRole,
                disabled: false
              }
            }
            let resetPosition = 'reset_' + 'player' + element.playerPosition + "_position";
            this.drawForm.controls[resetPosition].setValue(element.id);
            let playerDot = 'player' + element.playerPosition + '_dot';
            this.elementRef.nativeElement.querySelector('#' + playerDot).style.display = "block";
            this.elementRef.nativeElement.querySelector('#player' + element.playerPosition + '_dot').style.display = 'block';
            this.drawForm.get(control).disable();
            this.selectedPlayerList.push(playerObj);
          });
          this.getTournamentResultList();
        }
      },
      err => {
      }
    );
  }
  getTournamentResultList() {
    let query = "filterByDisable=false&filterByStatus=true&filterByTournamentId=" + this.tournamentId + "&filterByMatchId=" + this.selectedGroupId + "&filterByAgeGroup=" + this.selectedAgeGroupId;
    this.tournamentDrawService.getTournamentResultList(query).subscribe(
      data => {
        let roundResult = data.data.items;
        this.roundResult = roundResult;
        let resultLength = roundResult.length;
        if (roundResult.length > 0) {
          roundResult.forEach(element => {
            let round = element.round;
            let nextRound = Number(element.round) + Number(1);
            if (Number(round) === Number(1)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(1);
            }
            if (Number(round) === Number(2)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(2);
            }
          
            if (Number(round) === Number(3)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(4);
              //if (Number(resultLength) === Number(7) && (this.playersCount === Number(8) || (this.playersCount >= Number(4)))) {
              if (Number(resultLength) === Number(7) && (this.playersCount > Number(3))) {
                this.saveDrawButtonDisable = false;
              }
            }
            if (Number(round) === Number(4)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(8);
              //if (Number(resultLength) === Number(15) && (this.playersCount === Number(16) ||this.playersCount >= Number(8))) {
              if (Number(resultLength) === Number(15) && (this.playersCount > Number(7))) {
                this.saveDrawButtonDisable = false;
              }
            }
            if (Number(round) === Number(5)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(16);
              //if (Number(resultLength) === Number(31) && (this.playersCount === Number(32) ||this.playersCount >= Number(16))) {
              if (Number(resultLength) === Number(31) && (this.playersCount > Number(15))) {
                this.saveDrawButtonDisable = false;
              }
            }
            if (Number(round) === Number(6)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(32);
              //if (Number(resultLength) === Number(63) && (this.playersCount === Number(64) ||this.playersCount >= Number(32))) {
              if (Number(resultLength) === Number(63) && (this.playersCount > Number(31))) {
                this.saveDrawButtonDisable = false;
              }
            }
            if (Number(round) === Number(7)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(64);
              //if (Number(resultLength) === Number(127) && (this.playersCount === Number(128) ||this.playersCount >= Number(64))) {
              if (Number(resultLength) === Number(127) && (this.playersCount > Number(63))) {
                this.saveDrawButtonDisable = false;
              }
            }
            if (this.drawStatus === false) {
              this.elementRef.nativeElement.querySelector('#enter_three_dot_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'block';
              let positionControlOne = Number(this.formControlNumberOne);
              let positionControlTwo = Number(this.formControlNumberTwo) - Number(1);
              let positionControlThree = Number(this.formControlNumberOne) + Number(2);
              let positionControlFour = Number(this.formControlNumberTwo) + Number(1);
              let previousRound = Number(round) - Number(1);
              if (Number(round) !== Number(1)) {
                if (Number(round) === Number(3)) {
                  positionControlTwo = Number(this.formControlNumberTwo) - Number(2);
                  positionControlThree = Number(this.formControlNumberOne) + Number(4);
                  positionControlFour = Number(this.formControlNumberTwo) + Number(2);
                }
                if (Number(round) === Number(4)) {
                  positionControlTwo = Number(this.formControlNumberTwo) - Number(4);
                  positionControlThree = Number(this.formControlNumberOne) + Number(8);
                  positionControlFour = Number(this.formControlNumberTwo) + Number(4);
                }
                if (Number(round) === Number(5)) {
                  positionControlTwo = Number(this.formControlNumberTwo) - Number(8);
                  positionControlThree = Number(this.formControlNumberOne) + Number(16);
                  positionControlFour = Number(this.formControlNumberTwo) + Number(8);
                }
                if (Number(round) === Number(6)) {
                  positionControlTwo = Number(this.formControlNumberTwo) - Number(16);
                  positionControlThree = Number(this.formControlNumberOne) + Number(32);
                  positionControlFour = Number(this.formControlNumberTwo) + Number(16);
                }
                if (Number(this.round) === Number(7)) {
                  positionControlTwo = Number(this.formControlNumberTwo) - Number(32);
                  positionControlThree = Number(this.formControlNumberOne) + Number(64);
                  positionControlFour = Number(this.formControlNumberTwo) + Number(32);
                }

                if (this.totalEntries == Number(8)) {
                  if (Number(round) == Number(3)) {
                    previousRound = round;
                    positionControlTwo = Number(this.formControlNumberOne) + Number(4);
                  }
                }
                if (this.totalEntries == Number(16)) {
                  if (Number(round) == Number(4)) {
                    previousRound = round;
                    positionControlTwo = Number(this.formControlNumberOne) + Number(8);
                  }
                }
                if (this.totalEntries == Number(32)) {
                  if (Number(round) == Number(5)) {
                    previousRound = round;
                    positionControlTwo = Number(this.formControlNumberOne) + Number(16);
                  }
                }
                if (this.totalEntries == Number(64)) {
                  if (Number(round) == Number(6)) {
                    previousRound = round;
                    positionControlTwo = Number(this.formControlNumberOne) + Number(32);
                  }
                }
                if (this.totalEntries == Number(128)) {
                  if (Number(round) == Number(7)) {
                    previousRound = round;
                    positionControlTwo = Number(this.formControlNumberOne) + Number(64);
                  }
                }
                if (Number(previousRound) !== Number(round)) {
                  this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + positionControlOne + '_' + 'player' + positionControlTwo + '_round' + previousRound).style.display = 'none';
                  this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + positionControlThree + '_' + 'player' + positionControlFour + '_round' + previousRound).style.display = 'none';
                } else {
                  this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + positionControlOne + '_' + 'player' + positionControlTwo + '_round' + round).style.display = 'block';
                  // this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + positionControlThree + '_' + 'player' + positionControlFour + '_round' + round).style.display = 'block';
                }
              }
            }
            this.elementRef.nativeElement.querySelector('#player' + this.formControlNumberOne + '_dot').style.display = 'none';
            this.elementRef.nativeElement.querySelector('#player' + this.formControlNumberTwo + '_dot').style.display = 'none';
            this.elementRef.nativeElement.querySelector('#winner_id_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = element.id;
            this.elementRef.nativeElement.querySelector('#winner_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = element.winnerFullName;
            this.elementRef.nativeElement.querySelector('#enter_three_dot_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'none';
            this.elementRef.nativeElement.querySelector('#player' + this.formControlNumberOne + '_round' + nextRound).value = element.winnerId;
            let playerSetScoreData = [];
            if (element.matchconcededName !== undefined) {
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).
                insertAdjacentHTML('beforeend', '<div class="player-result">' + element.matchconcededName + '</div>');
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'block';
            } else if (element.score.length > 0) {
              let scoreData = element.score;
              let scoreArray = [];
              let scoreLength = element.score.length;
              let scoreMinutes = 0;
              let showScoreMinutes;
              if (element.score.length > 0) {
                // element.score.forEach(sElement => {
                //   scoreData.push({ score: sElement.player1Set + '-' + sElement.player2Set });
                // });
                for (let i = 0; i < scoreLength; i++) {
                  let playerOneData = scoreData[i].player1Set;
                  let playerTwoData = scoreData[i].player2Set;
                  // scoreMinutes = Number(scoreMinutes) + Number(scoreData[i].duration);
                  if (scoreData[i].player1TieBreak != 0 && scoreData[i].player1TieBreak < scoreData[i].player2TieBreak) {
                    playerOneData = scoreData[i].player1Set + "<sup>" + scoreData[i].player1TieBreak + "</sup>";
                  }
                  if (scoreData[i].player2TieBreak != 0 && scoreData[i].player1TieBreak > scoreData[i].player2TieBreak) {
                    playerTwoData = scoreData[i].player2Set + "<sup>" + scoreData[i].player2TieBreak + "</sup>";
                  }
                  scoreArray.push(playerOneData + '-' + playerTwoData + "  ");
                }
                // if (scoreMinutes == 0) {
                //   showScoreMinutes = '';
                // } else {
                //   showScoreMinutes = " (" + scoreMinutes + "M)";
                // }
                // scoreData['score'] = scoreData[0].player1Set + '-' + scoreData[0].player2Set;
                playerSetScoreData['playerSetScore'] = element.player1val + ' - ' + element.player2val;
                this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span  style="background-color:#11ab63; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;">' + playerSetScoreData['playerSetScore'] + '</span>' + scoreArray.join("") + "</div>");
                // this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = ;
              }
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'block';
            } else if (element.score.length === 0 && element.matchconcededName === undefined && element.player1val !== null && element.player2val !== null) {
              playerSetScoreData['playerSetScore'] = element.player1val + ' - ' + element.player2val;
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span class="" style="background-color:#6fc270; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;">' + playerSetScoreData['playerSetScore'] + '</span></div>');
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'block';
            } else {
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span class="" style="background-color:#6fc270; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;"></span></div>');
            }
          });
        }
        this.changeDetectorRef.detectChanges();
      },
      err => {
      }
    );
  }
  onClickPlayerDropdown(event, formControlNumber) {
    let playerId = event.value.id;
    let byeId = 'bye';
    let isBye: boolean;
    let playerRole = event.value.role;
    //this.playerList.forEach(element => {
    let reset = 'reset_' + 'player' + formControlNumber;
    let playerDot = 'player' + formControlNumber + '_dot';
    this.elementRef.nativeElement.querySelector('#' + playerDot).style.display = "block";
    let index = this.findIndexById(playerId, this.playerList);
    isBye = false;
    if (index != -1) {
      // element.disabled = true;
      if (playerId == this.playerList[index].id) {
        if (event.value.name === 'Bye') {
          byeId = 'player' + formControlNumber + "bye";
          this.drawForm.controls[reset].setValue(byeId);
          let Obj = {
            id: byeId,
            name: 'Bye',
            position: byeId,
            disable: false
          }
          this.isBye = true;
          isBye = true;
          this.selectedPlayerList.push(Obj);
        } else {
          this.playerList[index].position = formControlNumber;
          let positionControl: string | number;
          if (Number(this.playerList[index].position) % Number(2) === 0) {
            this.formControlNumberTwo = this.playerList[index].position;
            this.formControlNumberOne = Number(this.playerList[index].position) - Number(1);
            positionControl = Number(this.playerList[index].position) - Number(1);
          } else {
            this.formControlNumberTwo = Number(this.playerList[index].position) + Number(1);
            positionControl = Number(this.playerList[index].position) + Number(1);
            this.formControlNumberOne = this.playerList[index].position;
          }
          let playerPosition = 'player' + positionControl + 'bye';
          let byeIndex = this.findByePlayerPosition(playerPosition, this.selectedPlayerList);
          if (byeIndex !== -1) {
            let playerData = this.selectedPlayerList[byeIndex];
            if (playerData.name === 'Bye') {
              this.isBye = true;
              //isBye = false;
            }
          }
          this.drawForm.controls[reset].setValue(this.playerList[index].id);
          this.selectedPlayerList.push(this.playerList[index]);
          this.playerList.splice(index, 1);
        }
        this.drawForm.controls['player' + formControlNumber].disable();
      }
    }
    //});
    this.formControlNumber = formControlNumber;
    let playerObj = {
      tournamentId: this.tournamentId,
      matchTypeId: this.selectedGroupId,
      ageGroupId: this.selectedAgeGroupId,
      playerId: playerId,
      playerRole: playerRole,
      round: "1",
      playerPosition: formControlNumber,
      isBye: isBye,
      disable: false
    }
    this.tournamentDrawService.addTournamentPositions(playerObj).subscribe(
      async data => {
        let resetPosition = 'reset_' + 'player' + formControlNumber + "_position";
        this.drawForm.controls[resetPosition].setValue(data.id);
        if (this.isBye === true) {
          await this.onScoreSubmit().then(
            data => {
              this.isBye = false;
            }
          );
        }
        // this.isBye = false;
      },
      (err) => {
      }
    );
  }
  onClickIcon(formControl) {
    let reset = 'reset_' + formControl;
    let closeRemovePlayer = 'close_remove_' + formControl;
    this.elementRef.nativeElement.querySelector('#' + reset).style.display = "block";
    this.elementRef.nativeElement.querySelector('#' + closeRemovePlayer).style.display = "block";
  }
  onClickCloseRemoveIcon(formControl) {
    let reset = 'reset_' + formControl;
    let closeRemovePlayer = 'close_remove_' + formControl;
    this.elementRef.nativeElement.querySelector('#' + reset).style.display = "none";
    this.elementRef.nativeElement.querySelector('#' + closeRemovePlayer).style.display = "none";
  }
  onClickRoundThreeDotsIcon(round, position) {
    let positionNumber = 1;
    if (round == 2) {
      positionNumber = 2;
    }
    if (round == 3) {
      positionNumber = 4;
    }
    if (round == 4) {
      positionNumber = 8;
    }
    if (round == 5) {
      positionNumber = 16;
    }
    if (round == 6) {
      positionNumber = 32;
    }
    if (round == 7) {
      positionNumber = 64;
    }
    let positionOne = position;
    let positionTwo = Number(position) + Number(positionNumber);
    this.elementRef.nativeElement.querySelector('#enter_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
    this.elementRef.nativeElement.querySelector('#close_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
    this.elementRef.nativeElement.querySelector('#enter_close_div_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
  }
  onClickEnterThreeDotsIcon(round, position) {
    let positionOne = position;
    let positionTwo = Number(position) + Number(1);
    this.elementRef.nativeElement.querySelector('#enter_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
    this.elementRef.nativeElement.querySelector('#close_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
    this.elementRef.nativeElement.querySelector('#enter_close_div_player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
  }
  onClickEnterEditThreeDotsIcon(round, position) {
    let positionOne = position;
    let positionTwo = Number(position) + Number(1);
    this.elementRef.nativeElement.querySelector('#enter_edit_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
    this.elementRef.nativeElement.querySelector('#close_edit_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
    this.elementRef.nativeElement.querySelector('#enter_close_div_player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
  }
  onClickRoundEditThreeDotsIcon(round, position) {
    let positionNumber = 2;
    if (round == 3) {
      positionNumber = 4;
    }
    if (round == 4) {
      positionNumber = 8;
    }
    if (round == 5) {
      positionNumber = 16;
    }
    if (round == 6) {
      positionNumber = 32;
    }
    if (round == 7) {
      positionNumber = 64;
    }
    let positionOne = position;
    let positionTwo = Number(position) + Number(positionNumber);
    this.elementRef.nativeElement.querySelector('#enter_edit_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
    this.elementRef.nativeElement.querySelector('#close_edit_' + 'player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
    this.elementRef.nativeElement.querySelector('#enter_close_div_player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "block";
  }
  onClickEnterRound(round, formControlNumber) {
    this.round = round;
    let positionNumber = 1;
    if (round == 2) {
      positionNumber = 2;
    }
    if (round == 3) {
      positionNumber = 4;
    }
    if (round == 4) {
      positionNumber = 8;
    }
    if (round == 5) {
      positionNumber = 16;
    }
    if (round == 6) {
      positionNumber = 32;
    }
    if (round == 7) {
      positionNumber = 64;
    }
    let formControlNumberOne = formControlNumber;
    let formControlNumberTwo = Number(formControlNumber) + Number(positionNumber);
    // let positionOne = Number(formControlNumber) + Number(1);
    // let positionTwo = Number(formControlNumberTwo) + Number(1) + Number(formControlNumberTwo) + Number(2);
    let playerOnePosition = 'player' + formControlNumberOne + '_round' + round;
    let playerTwoPosition = 'player' + formControlNumberTwo + '_round' + round;
    this.formControlNumberOne = formControlNumberOne;
    this.formControlNumberTwo = formControlNumberTwo;
    let playerOneId = this.elementRef.nativeElement.querySelector('#player' + formControlNumberOne + '_round' + round).value;
    let playerTwoId = this.elementRef.nativeElement.querySelector('#player' + formControlNumberTwo + '_round' + round).value;
    let indexOfPlayerOne = this.findPlayerById(playerOneId, this.selectedPlayerList);
    let indexOfPlayerTwo = this.findPlayerById(playerTwoId, this.selectedPlayerList);
    this.playerOneDetails = undefined;
    this.playerTwoDetails = undefined;
    if (indexOfPlayerOne !== -1) {
      this.playerOneDetails = this.selectedPlayerList[indexOfPlayerOne];
      if (this.selectedPlayerList[indexOfPlayerOne].name === 'Bye') {
        return;
      }
      if (indexOfPlayerTwo !== -1) {
        this.playerTwoDetails = this.selectedPlayerList[indexOfPlayerTwo];
        if (this.selectedPlayerList[indexOfPlayerTwo].name === 'Bye') {
          return;
        }
      }
      if (this.playerTwoDetails !== undefined) {
        if (this.playerTwoDetails.length === 0) {
          this.playerOneDetails = undefined;
        }
      }
    }
    this.showScoreForm = true;
  }
  findPlayerById(id, array) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  onClickCloseIcon(round, position) {
    let positionOne = position;
    let positionTwo = Number(position) + Number(1);
    this.elementRef.nativeElement.querySelector('#enter_' + 'player' + positionOne + '_player' + positionTwo + '_round' + round).style.display = "none";
    this.elementRef.nativeElement.querySelector('#close_' + 'player' + positionOne + '_player' + positionTwo + '_round' + round).style.display = "none";
    this.elementRef.nativeElement.querySelector('#enter_close_div_player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "none";
  }
  onClickCloseEditIcon(round, position) {
    let positionOne = position;
    let positionTwo = Number(position) + Number(1);
    this.elementRef.nativeElement.querySelector('#enter_edit_' + 'player' + positionOne + '_player' + positionTwo + '_round' + round).style.display = "none";
    this.elementRef.nativeElement.querySelector('#close_edit_' + 'player' + positionOne + '_player' + positionTwo + '_round' + round).style.display = "none";
    this.elementRef.nativeElement.querySelector('#enter_close_div_player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "none";
  }
  onClickRoundCloseIcon(round, position) {
    let positionNumber = 1;
    if (round == 2) {
      positionNumber = 2;
    }
    if (round == 3) {
      positionNumber = 4;
    }
    if (round == 4) {
      positionNumber = 8;
    }
    if (round == 5) {
      positionNumber = 16;
    }
    if (round == 6) {
      positionNumber = 32;
    }
    if (round == 7) {
      positionNumber = 64;
    }
    let positionOne = position;
    let positionTwo = Number(position) + Number(positionNumber);
    this.elementRef.nativeElement.querySelector('#enter_' + 'player' + positionOne + '_player' + positionTwo + '_round' + round).style.display = "none";
    this.elementRef.nativeElement.querySelector('#close_' + 'player' + positionOne + '_player' + positionTwo + '_round' + round).style.display = "none";
    this.elementRef.nativeElement.querySelector('#enter_close_div_player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "none";
  }
  onClickRoundCloseEditIcon(round, position) {
    let positionNumber = 2;
    if (round == 3) {
      positionNumber = 4;
    }
    if (round == 4) {
      positionNumber = 8;
    }
    if (round == 5) {
      positionNumber = 16;
    }
    if (round == 6) {
      positionNumber = 32;
    }
    if (round == 7) {
      positionNumber = 64;
    }
    let positionOne = position;
    let positionTwo = Number(position) + Number(positionNumber);
    this.elementRef.nativeElement.querySelector('#enter_edit_' + 'player' + positionOne + '_player' + positionTwo + '_round' + round).style.display = "none";
    this.elementRef.nativeElement.querySelector('#close_edit_' + 'player' + positionOne + '_player' + positionTwo + '_round' + round).style.display = "none";
    this.elementRef.nativeElement.querySelector('#enter_close_div_player' + positionOne + '_' + 'player' + positionTwo + '_round' + round).style.display = "none";
  }
  onClickEnterIcon(round, formControlNumber) {
    this.round = round;
    let formControlNumberOne = formControlNumber;
    let formControlNumberTwo = Number(formControlNumber) + Number(1);
    this.formControlNumberOne = formControlNumberOne;
    this.formControlNumberTwo = formControlNumberTwo;
    let playerOnePosition = formControlNumberOne;
    let playerTwoPosition;
    playerTwoPosition = formControlNumberTwo;
    let reset1Value = this.drawForm.get("reset_player" + formControlNumberOne).value;
    let reset2Value = this.drawForm.get("reset_player" + formControlNumberTwo).value;
    if (reset1Value === playerOnePosition + 'bye') {
      playerOnePosition = playerOnePosition + 'bye';
    }
    if (reset2Value === playerTwoPosition + 'bye') {
      playerTwoPosition = playerTwoPosition + 'bye';
    }
    let indexOfPlayerOne = this.findPlayerPosition(playerOnePosition, this.selectedPlayerList);
    let indexOfPlayerTwo = this.findPlayerPosition(playerTwoPosition, this.selectedPlayerList);
    if (indexOfPlayerOne !== -1) {
      this.playerOneDetails = this.selectedPlayerList[indexOfPlayerOne];
      if (this.selectedPlayerList[indexOfPlayerOne].name === 'Bye') {
        return;
      }
      if (indexOfPlayerTwo !== -1) {
        this.playerTwoDetails = this.selectedPlayerList[indexOfPlayerTwo];
        if (this.selectedPlayerList[indexOfPlayerTwo].name === 'Bye') {
          return;
        }
      }
      if (this.playerTwoDetails === undefined) {
        this.playerOneDetails = undefined;
      }
    }
    this.showScoreForm = true;
  }
  onClickEnterEditIcon(round, formControlNumber) {
    this.round = round;
    let nextRound = Number(round) + Number(1);
    let positionNumber = 1;
    if (round == 2) {
      positionNumber = 2;
    }
    if (round == 3) {
      positionNumber = 4;
    }
    if (round == 4) {
      positionNumber = 8;
    }
    if (round == 5) {
      positionNumber = 16;
    }
    if (round == 6) {
      positionNumber = 32;
    }
    if (round == 7) {
      positionNumber = 64;
    }

    if (Number(this.totalEntries) === Number(8)) {
      if (Number(round) === Number(3)) {
        this.saveDrawButtonDisable = true;
      }
    }
    if (Number(this.totalEntries) === Number(16)) {
      if (Number(round) === Number(4)) {
        this.saveDrawButtonDisable = true;
      }
    }
    if (Number(this.totalEntries) === Number(32)) {
      if (Number(round) === Number(5)) {
        this.saveDrawButtonDisable = true;
      }
    }
    if (Number(this.totalEntries) === Number(64)) {
      if (Number(round) === Number(6)) {
        this.saveDrawButtonDisable = true;
      }
    }
    if (Number(this.totalEntries) === Number(128)) {
      if (Number(round) === Number(7)) {
        this.saveDrawButtonDisable = true;
      }
    }
    let formControlNumberOne = formControlNumber;
    let formControlNumberTwo = Number(formControlNumber) + Number(positionNumber);
    this.formControlNumberOne = formControlNumberOne;
    this.formControlNumberTwo = formControlNumberTwo;
    let playerOnePosition = formControlNumberOne;
    let playerTwoPosition;
    playerTwoPosition = formControlNumberTwo;
    let roundResultId = this.elementRef.nativeElement.querySelector('#winner_id_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value;
    let updateDrawData = '{"disable":' + true + '}';
    this.tournamentDrawService.updateTournamentDraw(roundResultId, updateDrawData).subscribe(
      data => {
        if (Number(this.round) === Number(1)) {
          this.elementRef.nativeElement.querySelector('#player' + this.formControlNumberOne + '_dot').style.display = 'block';
          this.elementRef.nativeElement.querySelector('#player' + this.formControlNumberTwo + '_dot').style.display = 'block';
        } else {
          let positionControlOne = Number(this.formControlNumberOne);
          let positionControlTwo = Number(this.formControlNumberTwo) - Number(1);
          let positionControlThree = Number(this.formControlNumberOne) + Number(2);
          let positionControlFour = Number(this.formControlNumberTwo) + Number(1);
          if (Number(this.round) === Number(3)) {
            positionControlTwo = Number(this.formControlNumberTwo) - Number(2);
            positionControlThree = Number(this.formControlNumberOne) + Number(4);
            positionControlFour = Number(this.formControlNumberTwo) + Number(2);
          }
          if (Number(this.round) === Number(4)) {
            positionControlTwo = Number(this.formControlNumberTwo) - Number(4);
            positionControlThree = Number(this.formControlNumberOne) + Number(8);
            positionControlFour = Number(this.formControlNumberTwo) + Number(4);
          }
          if (Number(this.round) === Number(5)) {
            positionControlTwo = Number(this.formControlNumberTwo) - Number(8);
            positionControlThree = Number(this.formControlNumberOne) + Number(16);
            positionControlFour = Number(this.formControlNumberTwo) + Number(8);
          }
          if (Number(this.round) === Number(6)) {
            positionControlTwo = Number(this.formControlNumberTwo) - Number(16);
            positionControlThree = Number(this.formControlNumberOne) + Number(32);
            positionControlFour = Number(this.formControlNumberTwo) + Number(16);
          }
          if (Number(this.round) === Number(7)) {
            positionControlTwo = Number(this.formControlNumberTwo) - Number(32);
            positionControlThree = Number(this.formControlNumberOne) + Number(64);
            positionControlFour = Number(this.formControlNumberTwo) + Number(32);
          }
          let previousRound = Number(this.round) - Number(1);
          this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + positionControlOne + '_' + 'player' + positionControlTwo + '_round' + previousRound).style.display = 'block';
          this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + positionControlThree + '_' + 'player' + positionControlFour + '_round' + previousRound).style.display = 'block';
        }
        // this.drawForm.get("reset_player" + formControlNumberOne + '_position').setValue('');
        this.elementRef.nativeElement.querySelector('#winner_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = 'TBD';
        this.elementRef.nativeElement.querySelector('#player' + this.formControlNumberOne + '_round' + nextRound).value = '';
        // this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = '';
        this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round + ' .player-result').
          remove();
        this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'none';
        // this.elementRef.nativeElement.querySelector('#enter_' + 'player' + this.formControlNumberOne + '_player' + this.formControlNumberTwo + '_round' + round).style.display = "block";
        this.elementRef.nativeElement.querySelector('#enter_three_dot_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'block';
        // this.elementRef.nativeElement.querySelector('#close_' + 'player' + this.formControlNumberOne + '_player' + this.formControlNumberTwo + '_round' + round).style.display = "block";
        this.elementRef.nativeElement.querySelector('#enter_edit_' + 'player' + this.formControlNumberOne + '_player' + this.formControlNumberTwo + '_round' + round).style.display = "none";
        this.elementRef.nativeElement.querySelector('#close_edit_' + 'player' + this.formControlNumberOne + '_player' + this.formControlNumberTwo + '_round' + round).style.display = "none";
        this.elementRef.nativeElement.querySelector('#enter_close_div_player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = "none";
        this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'none';
      },
      err => {
      }
    );
  }
  onChangeMatchConcedeCategory(event) {
    this.selectedMatchConcedeCategory = event.value.value;
    this.showPlayerRadioButtons = true;
    this.showDetailScoringCheckBox = false;
    this.showSetScoreTable = false;
    this.showRadioButtonError = false;
    this.errorOneResult = false;
    this.showWrongScoreError = false;
    this.showScoreInputError = false;
  }
  findPlayerPosition(position, array) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      if (Number(array[i].position) === Number(position)) {
        index = i;
        break;
      }
    }
    return index;
  }
  findByePlayerPosition(position, array) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      if (array[i].position === position) {
        index = i;
        break;
      }
    }
    return index;
  }
  createSetsDetailsInputs(eventType, event) {
    let playerOneInput;
    let playerTwoInput;
    this.errorOneResult = false;
    this.showWrongScoreError = false;
    if (eventType == 'keyup') {
      if (event.value > 5) {
        return;
      }
      playerOneInput = this.scoreForm.controls.playerOne.value;
      playerTwoInput = this.scoreForm.controls.playerTwo.value;
    } else {
      playerOneInput = this.scoreForm.controls.playerOne.value;
      playerTwoInput = this.scoreForm.controls.playerTwo.value;
    }
    if (playerOneInput === null || playerTwoInput === null) {
      this.showScoreInputError = true;
      return;
    }
    if (playerOneInput === playerTwoInput) {
      this.showScoreInputError = true;
      return;
    }
    if (playerOneInput > playerTwoInput) {
      //this.playerPosition = 'player1';
      this.playerOneInputValue = playerOneInput;
    } else {
      //this.playerPosition = "player2";
      this.playerTwoInputValue = playerTwoInput;
    }
    if (playerOneInput !== '' && playerTwoInput !== '') {
      this.showScoreInputError = false;
      this.totalSets = [];
      let totalSets = Number(playerOneInput) + Number(playerTwoInput);
      for (let i = 0; i < totalSets; i++) {
        this.totalSets.push({ "index": i });
      }
    }
    this.scoreSectionForm().controls = [];
    this.totalSets.forEach(element => {
      this.addScoreForm();
    });
  }
  addScoreForm() {
    this.scoreSectionForm().push(this.newScoreForm());
  }
  newScoreForm(): FormGroup {
    return this.formBuilder.group({
      player1Set: [null, [Validators.required]],
      player2Set: [null, [Validators.required]],
      player1TieBreak: [null],
      player2TieBreak: [null],
      // duration: [null, [Validators.required]],
    })
  }
  onCheckDetail(event) {
    this.errorOneResult = false;
    this.showWrongScoreError = false;
    if (event.checked) {
      this.showSetScoreTable = true;
    } else {
      this.showSetScoreTable = false;
      this.playerScoreArray = [];
    }
  }
  onClickReset(formControl) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to Remove this player?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let playerId = this.drawForm.get("reset_player" + formControl).value;
        let playerDot = "player" + formControl + '_dot';
        this.elementRef.nativeElement.querySelector('#' + playerDot).style.display = "none";
        let reset = 'reset_' + "player" + formControl;
        let closeRemovePlayer = 'close_remove_player' + formControl;
        this.elementRef.nativeElement.querySelector('#' + reset).style.display = "none";
        this.elementRef.nativeElement.querySelector('#' + closeRemovePlayer).style.display = "none";
        let playerPositionId = this.drawForm.get("reset_player" + formControl + "_position").value;
        let index = this.findIndexById(playerId, this.selectedPlayerList);
        this.playerOneDetails = undefined;
        this.playerTwoDetails = undefined;
        if (index != -1) {
          if (this.selectedPlayerList[index].name !== 'Bye') {
            this.playerList.push(this.selectedPlayerList[index]);
          }
          this.selectedPlayerList.splice(index, 1);
          this.drawForm.controls["player" + formControl].enable();
          this.drawForm.controls["player" + formControl].setValue('');
          let playerData = {
            disable: true
          }
          this.tournamentDrawService.updateTournamentPositions(playerPositionId, playerData).subscribe(
            data => {
              this.playerOneDetails = undefined;
              this.playerTwoDetails = undefined;
            },
            err => {
            }
          )
        }
      },
      reject: () => {
      }
    });
  }
  findIndexById(id, array) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  onRadioButtonClick(event) {
    this.showRadioButtonError = false;
  }
  onCloseModal() {
    this.showScoreForm = false;
    this.showPlayerRadioButtons = false;
    this.showScoreInputError = false;
    this.showSetScoreTable = false;
    this.showDetailScoringCheckBox = true;
    this.selectedPlayerValue = undefined;
    this.playerOneInputValue = undefined;
    this.playerTwoInputValue = undefined;
    this.playerOneDetails = undefined;
    this.playerTwoDetails = undefined;
    this.errorOneResult = false;
    this.showWrongScoreError = false;
    this.scoreSectionForm().controls = [];
    this.selectedMatchConcedeCategory = undefined;
    if (this.formControlNumberOne !== undefined) {
      this.elementRef.nativeElement.querySelector('#enter_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + "_round" + this.round).style.display = "none";
      this.elementRef.nativeElement.querySelector('#close_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + "_round" + this.round).style.display = "none";
      this.elementRef.nativeElement.querySelector('#enter_close_div_player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + this.round).style.display = "none";
    }
    this.scoreForm.reset();
    this.scoreSubmitted = false;
    this.scoreInputForm.reset();
    this.formControlNumberOne = 0;
    this.formControlNumberTwo = 0;
  }
  async onScoreSubmit() {
    let selectedPlayerId;
    let selectedPlayerDetails;
    let playerId = null;
    if (this.showScoreInputError === true) {
      return;
    }
    if (this.selectedMatchConcedeCategory !== undefined) {
      if (this.selectedPlayerValue == undefined) {
        this.showRadioButtonError = true;
        return;
      } else {
        this.showRadioButtonError = false;
      }
      selectedPlayerId = this.selectedPlayerValue;
      let indexOfSelectedPlayer = this.findIndexById(selectedPlayerId, this.selectedPlayerList);
      if (indexOfSelectedPlayer !== -1) {
        selectedPlayerDetails = this.selectedPlayerList[indexOfSelectedPlayer];
        playerId = selectedPlayerDetails.id;
        //this.playerPosition = selectedPlayerDetails.position;
      }
      // this.playerOneInputValue = this.scoreForm.controls.playerOne.setValue('');
      // this.playerTwoInputValue = this.scoreForm.controls.playerTwo.setValue('');
      this.playerScoreArray = [];
    } else if (this.showSetScoreTable == true) {
      this.playerScoreArray = this.scoreInputForm.value.scoreArray;
      this.scoreSubmitted = true;
      if (this.scoreInputForm.invalid) {//} && this.step == 1) {
        return;
      }
      if (this.playerOneDetails === undefined) {
        return;
      }
      if (this.playerTwoDetails === undefined) {
        return;
      }
      this.playerOneInputValue = this.scoreForm.controls.playerOne.value;
      this.playerTwoInputValue = this.scoreForm.controls.playerTwo.value;
      if (Number(this.playerOneInputValue) === Number(0) && Number(this.playerTwoInputValue) === Number(0)) {
        this.showWrongScoreError = true;
        return;
      } else {
        this.showWrongScoreError = false;
      }
      if (Number(this.playerOneInputValue) === null && Number(this.playerTwoInputValue) === null) {
        this.showWrongScoreError = true;
        return;
      } else {
        this.showWrongScoreError = false;
      }
      if (Number(this.playerOneInputValue) > Number(this.playerTwoInputValue)) {
        playerId = this.playerOneDetails.id;
      } else {
        playerId = this.playerTwoDetails.id;
      }
      let winnerCount = 0;
      let isOneError = 0;
      let isSameOneValueEnterError = 0;
      let isSameOneTieBreakError = 0;
      let oneTieBreakError = 0;
      if (Number(this.playerOneInputValue) > Number(this.playerTwoInputValue)) {
        await this.playerScoreArray.forEach((element, index) => {
          if (element.player1Set > element.player2Set) {
            winnerCount++;
          }
          if (Number(element.player1Set) === Number(element.player2Set)) {
            isSameOneValueEnterError++;
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player1TieBreak === this.scoreInputForm.controls.scoreArray['controls'][index].value.player2TieBreak) {
              this.elementRef.nativeElement.querySelector('#playerTieBreak_same_error' + index).style.display = 'block';
              isSameOneTieBreakError++;
              return;
            } else {
              this.elementRef.nativeElement.querySelector('#playerTieBreak_same_error' + index).style.display = 'none';
            }
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player1TieBreak > this.scoreInputForm.controls.scoreArray['controls'][index].value.player2TieBreak) {
              oneTieBreakError++;
            }
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player1TieBreak > this.scoreInputForm.controls.scoreArray['controls'][index].value.player2TieBreak) {
              winnerCount++;
              oneTieBreakError--;
            }
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player1TieBreak === null) {
              this.elementRef.nativeElement.querySelector('#player1TieBreak_error' + index).style.display = 'block';
              isOneError++;
              return;
            } else {
              this.elementRef.nativeElement.querySelector('#player1TieBreak_error' + index).style.display = 'none';
              //this.elementRef.nativeElement.querySelector('#player2TieBreak_error' + index).style.display = 'none';
            }
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player2TieBreak === null) {
              this.elementRef.nativeElement.querySelector('#player2TieBreak_error' + index).style.display = 'block';
              isOneError++;
              return;
            } else {
              // this.elementRef.nativeElement.querySelector('#player1TieBreak_error' + index).style.display = 'none';
              this.elementRef.nativeElement.querySelector('#player2TieBreak_error' + index).style.display = 'none';
            }
          }
        });
        if (isSameOneTieBreakError > 0) {
          return;
        }
        if (isOneError > 0) {
          return;
        }
        if (Number(winnerCount) !== Number(this.playerOneInputValue)) {
          this.showWrongScoreError = true;
          return;
        } else if (isSameOneTieBreakError > 0 || oneTieBreakError > 0) {
          this.showWrongScoreError = true;
          return;
        } else {
          this.showWrongScoreError = false;
        }
      }
      let isError = 0;
      let isSameTieBreakError = 0;
      let isSameValueEnterError = 0;
      let tieBreakError = 0;
      if (Number(this.playerTwoInputValue) > Number(this.playerOneInputValue)) {
        this.playerScoreArray.forEach((element, index) => {
          if (element.player2Set > element.player1Set) {
            winnerCount++;
          }
          if (Number(element.player1Set) === Number(element.player2Set)) {
            isSameValueEnterError++;
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player1TieBreak === this.scoreInputForm.controls.scoreArray['controls'][index].value.player2TieBreak) {
              this.elementRef.nativeElement.querySelector('#playerTieBreak_same_error' + index).style.display = 'block';
              isSameTieBreakError++;
              return;
            } else {
              this.elementRef.nativeElement.querySelector('#playerTieBreak_same_error' + index).style.display = 'none';
            }
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player1TieBreak < this.scoreInputForm.controls.scoreArray['controls'][index].value.player2TieBreak) {
              tieBreakError++;
            }
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player1TieBreak < this.scoreInputForm.controls.scoreArray['controls'][index].value.player2TieBreak) {
              winnerCount++;
              tieBreakError--;
            }
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player1TieBreak === null) {
              this.elementRef.nativeElement.querySelector('#player1TieBreak_error' + index).style.display = 'block';
              isError++;
              return;
            } else {
              this.elementRef.nativeElement.querySelector('#player1TieBreak_error' + index).style.display = 'none';
              //this.elementRef.nativeElement.querySelector('#player2TieBreak_error' + index).style.display = 'none';
            }
            if (this.scoreInputForm.controls.scoreArray['controls'][index].value.player2TieBreak === null) {
              this.elementRef.nativeElement.querySelector('#player2TieBreak_error' + index).style.display = 'block';
              isError++;
              return;
            } else {
              // this.elementRef.nativeElement.querySelector('#player1TieBreak_error' + index).style.display = 'none';
              this.elementRef.nativeElement.querySelector('#player2TieBreak_error' + index).style.display = 'none';
            }
          }
        });
        if (isSameTieBreakError > 0) {
          return;
        }
        if (isError > 0) {
          return;
        }
        if (Number(winnerCount) !== Number(this.playerTwoInputValue)) {
          this.showWrongScoreError = true;
          return;
        } else if (isSameTieBreakError > 0 || tieBreakError > 0) {
          // console.log(isSameValueEnterError);
          this.showWrongScoreError = true;
          return;
        } else {
          this.showWrongScoreError = false;
        }
      }
      // if (this.playerScoreArray.length === 0) {
      //   this.detailResultError = true;
      //   return;
      // } else {
      //   this.detailResultError = false;
      // }
    } else if (this.isBye === true) {
      let formControlNumberOne = 0;
      let formControlNumberTwo = 0;
      if (Number(this.formControlNumber) % Number(2) === 0) {
        this.formControlNumberTwo = this.formControlNumber;
        this.formControlNumberOne = Number(this.formControlNumber) - Number(1);
      } else {
        this.formControlNumberOne = this.formControlNumber;
        this.formControlNumberTwo = Number(this.formControlNumber) + Number(1);
      }
      let indexOfPlayerOne = this.findPlayerPosition(this.formControlNumberOne, this.selectedPlayerList);
      let indexOfPlayerTwo = this.findPlayerPosition(this.formControlNumberTwo, this.selectedPlayerList);
      if (indexOfPlayerOne !== -1) {
        this.playerOneDetails = this.selectedPlayerList[indexOfPlayerOne];
        playerId = this.selectedPlayerList[indexOfPlayerOne].id;
      } else {
        this.playerOneDetails = undefined;
      }
      if (indexOfPlayerTwo !== -1) {
        this.playerTwoDetails = this.selectedPlayerList[indexOfPlayerTwo];
        playerId = this.selectedPlayerList[indexOfPlayerTwo].id;
      } else {
        this.playerTwoDetails = undefined;
      }
      this.playerOneInputValue = null;
      this.playerTwoInputValue = null;
      if (this.playerOneDetails !== undefined) {
        if (this.playerOneDetails.length === 0) {
          this.playerOneDetails = undefined;
        }
      }
      if (this.playerTwoDetails !== undefined) {
        if (this.playerTwoDetails.length === 0) {
          this.playerTwoDetails = undefined;
        }
      }
      if (playerId === null) {
        return;
      }
      this.round = 1;
    } else {
      this.playerOneInputValue = this.scoreForm.controls.playerOne.value;
      this.playerTwoInputValue = this.scoreForm.controls.playerTwo.value;
      if (this.scoreForm.controls.playerOne.value === '' || this.playerOneInputValue === null) {
        this.errorOneResult = true;
        return;
      } else {
        this.errorOneResult = false;
      }
      if (this.scoreForm.controls.playerTwo.value === '' || this.playerTwoInputValue === null) {
        this.errorOneResult = true;
        return;
      } else {
        this.errorOneResult = false;
      }
      if (Number(this.playerOneInputValue) > Number(this.playerTwoInputValue)) {
        playerId = this.playerOneDetails.id;
      } else {
        playerId = this.playerTwoDetails.id;
      }
    }
    let player1Id = null;
    let player2Id = null;
    if (this.playerOneDetails !== undefined) {
      player1Id = this.playerOneDetails.id;
    }
    if (this.playerTwoDetails !== undefined) {
      player2Id = this.playerTwoDetails.id;
    }
    let drawObj = {
      tournamentId: this.tournamentId,
      matchId: this.selectedGroupId,
      agegroupId: this.selectedAgeGroupId,
      player1Id: player1Id,
      player2Id: player2Id,
      winner: playerId,
      round: this.round,
      player1val: this.playerOneInputValue,
      player2val: this.playerTwoInputValue,
      match_conceded_type: this.selectedMatchConcedeCategory,
      playerPosition: this.formControlNumberOne,
      score: this.playerScoreArray,
      disable: false
    }
    if (drawObj.winner === null || drawObj.winner === undefined) {
      this.errorOneResult = true;
      return;
    } else {
      this.errorOneResult = false;
    }
    this.tournamentDrawService.addTournamentDraw(drawObj).subscribe(
      async data => {

        this.showPlayerRadioButtons = false;
        this.showScoreInputError = false;
        this.showSetScoreTable = false;
        this.showDetailScoringCheckBox = true;
        this.selectedPlayerValue = undefined;
        this.playerOneInputValue = 0;
        this.playerTwoInputValue = 0;
        this.playerScoreArray = [];
        this.selectedMatchConcedeCategory = undefined;
        // let positionNumber = 2;
        // if (this.round == 3) {
        //   positionNumber = 4;
        // }
        // if (this.round == 4) {
        //   positionNumber = 8;
        // }
        // if (this.round == 5) {
        //   positionNumber = 16;
        // }
        // if (this.round == 6) {
        //   positionNumber = 32;
        // }
        this.scoreSectionForm().controls = [];
        this.elementRef.nativeElement.querySelector('#enter_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + "_round" + this.round).style.display = "none";
        this.elementRef.nativeElement.querySelector('#close_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + "_round" + this.round).style.display = "none";
        this.elementRef.nativeElement.querySelector('#enter_close_div_player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + this.round).style.display = "none";
        this.elementRef.nativeElement.querySelector('#enter_three_dot_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + this.round).style.display = 'none';
        this.scoreForm.reset();
        this.scoreSubmitted = false;
        this.scoreInputForm.reset();
        await this.getTournamentResult(data.id, this.round, this.formControlNumberOne, this.formControlNumberTwo);
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Result added successfully.', life: 5000 });
        this.showScoreForm = false;
        this.playerOneDetails == undefined;
        this.playerTwoDetails == undefined;
      },
      err => {
      }
    );
  }
  async getTournamentResult(tournamentPlayerDrawId, round, formControlNumberOne, formControlNumberTwo) {
    let query = "";
    this.tournamentDrawService.getTournamentResult(tournamentPlayerDrawId, query).subscribe(
      data => {
        this.result = data;
        let nextRound = Number(round) + Number(1);
        this.elementRef.nativeElement.querySelector('#winner_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).value = data.winnerFullName;
        this.elementRef.nativeElement.querySelector('#winner_id_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).value = data.id;
        this.elementRef.nativeElement.querySelector('#player' + formControlNumberOne + '_round' + nextRound).value = data.winnerId;

        if (Number(this.totalEntries) === Number(8) && (this.playersCount === Number(8) || this.playersCount === Number(4))) {
          if (Number(round) === Number(3)) {
            this.saveDrawButtonDisable = false;
          }
        }
        if (Number(this.totalEntries) === Number(16) && (this.playersCount === Number(16) || this.playersCount === Number(8))) {
          if (Number(round) === Number(4)) {
            this.saveDrawButtonDisable = false;
          }
        }
        if (Number(this.totalEntries) === Number(32) && (this.playersCount === Number(32) || this.playersCount === Number(16))) {
          if (Number(round) === Number(5)) {
            this.saveDrawButtonDisable = false;
          }
        }
        if (Number(this.totalEntries) === Number(64) && (this.playersCount === Number(64) || this.playersCount === Number(32))) {
          if (Number(round) === Number(6)) {
            this.saveDrawButtonDisable = false;
          }
        }
        if (Number(this.totalEntries) === Number(128) && (this.playersCount === Number(128) || this.playersCount === Number(64))) {
          if (Number(round) === Number(7)) {
            this.saveDrawButtonDisable = false;
          }
        }
        let playerSetScoreData = [];
        if (data.matchconcededName !== undefined) {
          this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).
            insertAdjacentHTML('beforeend', '<div class="player-result">' + data.matchconcededName + '</div>');
          this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).style.display = 'block';
        } else if (data.score.length > 0) {
          let scoreData = data.score;
          let scoreArray = [];
          let scoreLength = data.score.length;
          let scoreMinutes = 0;
          let showScoreMinutes;
          if (data.score.length > 0) {
            // element.score.forEach(sElement => {
            //   scoreData.push({ score: sElement.player1Set + '-' + sElement.player2Set });
            // });
            for (let i = 0; i < scoreLength; i++) {
              let playerOneData = scoreData[i].player1Set;
              let playerTwoData = scoreData[i].player2Set;
              // scoreMinutes = Number(scoreMinutes) + Number(scoreData[i].duration);
              if (scoreData[i].player1TieBreak != 0 && scoreData[i].player1TieBreak < scoreData[i].player2TieBreak) {
                playerOneData = scoreData[i].player1Set + "<sup>" + scoreData[i].player1TieBreak + "</sup>";
              }
              if (scoreData[i].player2TieBreak != 0 && scoreData[i].player1TieBreak > scoreData[i].player2TieBreak) {
                playerTwoData = scoreData[i].player2Set + "<sup>" + scoreData[i].player2TieBreak + "</sup>";
              }
              scoreArray.push(playerOneData + '-' + playerTwoData + "  ");
            }
            // if (scoreMinutes == 0) {
            //   showScoreMinutes = '';
            // } else {
            //   showScoreMinutes = "(" + scoreMinutes + "M)";
            // }
            // scoreData['score'] = scoreData[0].player1Set + '-' + scoreData[0].player2Set;
            playerSetScoreData['playerSetScore'] = data.player1val + ' - ' + data.player2val;
            this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span  style="background-color:#11ab63; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;">' + playerSetScoreData['playerSetScore'] + '</span>' + scoreArray.join("") + "</div>");
            // this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = ;
          }
          this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).style.display = 'block';
        } else if (data.score.length === 0 && data.matchconcededName === undefined && data.player1val !== null && data.player2val !== null) {
          playerSetScoreData['playerSetScore'] = data.player1val + ' - ' + data.player2val;
          this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span class="" style="background-color:#6fc270; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;">' + playerSetScoreData['playerSetScore'] + '</span></div>');
          this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).style.display = 'block';
        } else {
          this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span class="" style="background-color:#6fc270; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;"></span></div>');
        }
        // this.elementRef.nativeElement.querySelector('#enter_edit_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + "_round" + this.round).style.display = "block";
        // this.elementRef.nativeElement.querySelector('#close_edit_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + "_round" + this.round).style.display = "block";
        this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + formControlNumberOne + '_' + 'player' + formControlNumberTwo + '_round' + this.round).style.display = 'block';
        if (Number(this.round) === Number(1)) {
          this.elementRef.nativeElement.querySelector('#player' + formControlNumberOne + '_dot').style.display = 'none';
          this.elementRef.nativeElement.querySelector('#player' + formControlNumberTwo + '_dot').style.display = 'none';
        } else {
          let positionControlOne = Number(formControlNumberOne);
          let positionControlTwo = Number(formControlNumberTwo) - Number(1);
          let positionControlThree = Number(formControlNumberOne) + Number(2);
          let positionControlFour = Number(formControlNumberTwo) + Number(1);
          if (Number(this.round) === Number(3)) {
            positionControlTwo = Number(formControlNumberTwo) - Number(2);
            positionControlThree = Number(formControlNumberOne) + Number(4);
            positionControlFour = Number(formControlNumberTwo) + Number(2);
          }
          if (Number(this.round) === Number(4)) {
            positionControlTwo = Number(formControlNumberTwo) - Number(4);
            positionControlThree = Number(formControlNumberOne) + Number(8);
            positionControlFour = Number(formControlNumberTwo) + Number(4);
          }
          if (Number(this.round) === Number(5)) {
            positionControlTwo = Number(formControlNumberTwo) - Number(8);
            positionControlThree = Number(formControlNumberOne) + Number(16);
            positionControlFour = Number(formControlNumberTwo) + Number(8);
          }
          if (Number(this.round) === Number(6)) {
            positionControlTwo = Number(formControlNumberTwo) - Number(16);
            positionControlThree = Number(formControlNumberOne) + Number(32);
            positionControlFour = Number(formControlNumberTwo) + Number(16);
          }
          if (Number(this.round) === Number(7)) {
            positionControlTwo = Number(formControlNumberTwo) - Number(32);
            positionControlThree = Number(formControlNumberOne) + Number(64);
            positionControlFour = Number(formControlNumberTwo) + Number(32);
          }
          let previousRound = Number(this.round) - Number(1);
          this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + positionControlOne + '_' + 'player' + positionControlTwo + '_round' + previousRound).style.display = 'none';
          this.elementRef.nativeElement.querySelector('#enter_edit_three_dot_' + 'player' + positionControlThree + '_' + 'player' + positionControlFour + '_round' + previousRound).style.display = 'none';
        }
      },
      err => {
      }
    );
  }
  onScoreReset() {
    this.scoreSubmitted = false;
    this.scoreInputForm.reset();
  }
  onClickSaveButton() {
    this.confirmationService.confirm({
      message: 'Please review the player results carefully, as once the scores are published, they will not be editable. <br>Are you sure you want to finalize this Tournament Draw?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let drawStatus = true;
        let tournamentCategoryData = '{"drawStatus":' + drawStatus + '}';
        // this.tournamentService.sendCategory({ categoryId: this.selectedGroupId, ageGroupId: this.selectedAgeGroupId });
        //this.tournamentService.updatecategory(this.tournamentCategoryId, tournamentCategoryData).subscribe(
        this.tournamentService.saveDraw(this.tournamentCategoryId, tournamentCategoryData).subscribe(
          data => {
            setTimeout(() => {
              this.router.navigate(['tournaments/factsheet/' + this.tournamentId]);
            }, 2000);
            this.saveDrawButtonDisable = true;
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'We are calculating result. Please check result tab after sometime', life: 5000 });
          },
          err => {
            this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.message, life: 6000 });
          }
        )
      },
      reject: () => {
      }
    });
  }
  captureScreenshot() {
    this.isHighlighted = true;
    const element = this.captureMe.nativeElement;
    const body = document.body;
    body.classList.add('capturing-screenshot');
    // Apply custom CSS styles when capturing
    // element.style.backgroundColor = 'yellow'; // Change to your desired styles
    // element.style.border = '2px solid orange';

    // Capture the screenshot using html2canvas
    // html2canvas(element).then((canvas) => {

    //   // Convert the canvas to a data URL (image)
    //   const dataURL = canvas.toDataURL('image/png');

    //   // Create a temporary link to download the screenshot
    //   const link = document.createElement('a');
    //   link.href = dataURL;
    //   link.download = 'tpl-draw.png';

    //   // Trigger a click event to download the screenshot
    //   link.click();

    //   // Reset the CSS styles after a delay (adjust the delay as needed)
    //   setTimeout(() => {
    //     element.style.backgroundColor = ''; // Reset to default or '' for no background
    //     element.style.border = ''; // Reset to default or '' for no border
    //     this.isHighlighted = false;
    //     body.classList.remove('capturing-screenshot');
    //   }, 1000); // Reset after 2 seconds (adjust the delay as needed)
    // });
  }
  helpModal() {
    this.helpPopupModal = true;
  }
}
